import React from 'react';

const {
    Provider: CallcenterAPIProvider,
    Consumer: CallcenterAPIConsumer,
} = React.createContext();

export { CallcenterAPIProvider, CallcenterAPIConsumer };
